module.exports = __webpack_public_path__ + "img/tenants.b87c72ed.svg";